module.exports = __webpack_public_path__ + "static/media/icon-gear-256.453d4a44.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/sprites/256x256/icon-gear-256.png
// module id = 829
// module chunks = 0